// src/pages/Tier.js
import React, { useEffect, useState } from "react";
import axios from "axios";
import WorkerSidebar from "../components/WorkerSidebar";

const Tier = () => {
  const [worker, setWorker] = useState(null);
  const workerId = localStorage.getItem("workerId");

  useEffect(() => {
    if (!workerId) return;

    axios
      .get(`http://localhost:5000/api/worker/profile/${workerId}`)
      .then((res) => setWorker(res.data))
      .catch((err) => console.error("Error loading tier info:", err));
  }, [workerId]);

  if (!worker) return <div className="p-6">Loading...</div>;

  const { tier, points } = worker;

  const tierDetails = {
    silver: {
      color: "gray",
      next: "Gold",
      nextThreshold: 200,
      bonus: 50,
    },
    gold: {
      color: "yellow",
      next: "Platinum",
      nextThreshold: 500,
      bonus: 100,
    },
    platinum: {
      color: "purple",
      next: null,
      nextThreshold: null,
      bonus: 0,
    },
  };

  const current = tierDetails[tier];
  const progress = current.nextThreshold
    ? Math.min((points / current.nextThreshold) * 100, 100)
    : 100;

  return (
    <div className="flex bg-gray-50 min-h-screen">
      <WorkerSidebar />
      <div className="ml-0 md:ml-60 p-6 w-full max-w-4xl text-gray-800">
        <h1 className="text-3xl font-extrabold mb-6 text-blue-700 flex items-center gap-2">
          🏆 Your Worker Tier
        </h1>

        <div className="bg-white rounded-xl shadow-md p-6 mb-6">
          <p className="text-xl font-semibold">
            Current Tier: <span className="capitalize text-gray-700">{tier}</span>
          </p>
          <p className="mt-1 text-sm text-gray-600">Points: {points}</p>

          {current.next && (
            <>
              <p className="mt-3 text-sm text-gray-700">
                Earn <strong>{current.nextThreshold - points}</strong> more points to reach <strong>{current.next}</strong> Tier
              </p>
              <div className="h-4 bg-gray-200 rounded-full mt-2">
                <div
                  className={`h-4 bg-blue-500 rounded-full transition-all duration-500`}
                  style={{ width: `${progress}%` }}
                ></div>
              </div>
            </>
          )}

          <div className="mt-4 bg-green-100 border border-green-300 text-green-800 px-4 py-2 rounded-md text-sm font-medium">
            💰 Bonus: ${tierDetails[tier].bonus} bonus when you hit {tier === "silver" ? "Gold" : tier === "gold" ? "Platinum" : "this"} tier
          </div>
        </div>

        <h2 className="text-xl font-bold mb-2 text-blue-700">
          📈 Tier Benefits & Reset
        </h2>
        <ul className="list-disc ml-6 space-y-2 text-sm text-gray-700">
          <li><strong>Silver Tier:</strong> Default. 15% commission.</li>
          <li><strong>Gold Tier:</strong> Earn 200+ points. <span className="text-yellow-600">12% commission</span>. 💰 <strong>$50 bonus</strong>.</li>
          <li><strong>Platinum Tier:</strong> Earn 500+ points. <span className="text-purple-600">10% commission</span>. 💰 <strong>$100 bonus</strong>.</li>
          <li>Points reset every 3 months to keep the tier competitive and active.</li>
          <li>⭐ <strong>5-star reviews = 5 points</strong>. Completing jobs = 5 points. Stay consistent!</li>
        </ul>

        <h2 className="text-xl font-bold mt-6 mb-2 text-yellow-600">
          💡 How to Earn More:
        </h2>
        <ul className="list-disc ml-6 space-y-2 text-sm text-gray-700">
          <li>Respond to job requests quickly</li>
          <li>Complete jobs on time and with professionalism</li>
          <li>Encourage customers to leave a 5-star review</li>
          <li>Avoid complaints and cancellations</li>
        </ul>
      </div>
    </div>
  );
};

export default Tier;
